import { useSelector, useDispatch } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';

const AppModal = () => {
  const dispatch = useDispatch();
  const { open, title, message, payload, callback } = useSelector(state => state.modal);

  const handleOptionSelect = (userType) => {
    if (callback) {
      callback(userType);
    }
    dispatch({ type: 'HIDE_MODAL' });
  };

  return (
    <Dialog open={open} onClose={() => dispatch({ type: 'HIDE_MODAL' })}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {message && <Typography>{message}</Typography>}

        {payload?.type === 'CHOICE_MODAL' && (
          <div style={{ marginTop: '1rem' }}>
            {payload.options.map(option => (
              <Button
                key={option}
                variant="outlined"
                onClick={() => handleOptionSelect(option.toLowerCase())}
                style={{ marginRight: '0.5rem' }}
              >
                {option}
              </Button>
            ))}
          </div>
        )}

        {payload?.type === 'ANY_MODAL' && (
          <div style={{ marginTop: '1rem' }}>
            {payload?.html}
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => dispatch({ type: 'HIDE_MODAL' })}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppModal;
